import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {UserList} from "./UserList";
import {UserDtl} from "./UserDtl";
import {PayList} from "./PayList";
import {PayDtl} from "./PayDtl";
import {ExpList} from "./ExpList";
import {ExpDtl} from "./ExpDtl";
import {PayGrpList} from "./common/PayGrpList";
import {RoyList} from "./RoyList";
import {RoyDtl} from "./RoyDtl";
import {ItemList} from './ItemList';

export const RoutePaths = {
  root: {
    pay_list: '/pay_list/',
    pay_ini: '/pay_dtl/',
    pay_dtl: '/pay_dtl/:pay_id',
    exp_list: '/exp_list/',
    exp_ini: '/exp_dtl/',
    exp_dtl: '/exp_dtl/:exp_id',
    roy_list: '/roy_list/',
    roy_ini: '/roy_dtl/',
    roy_dtl: '/roy_dtl/:roy_id',
    item_list: '/item_list/',
    user_list: '/user_list/',
    user_ini: '/user/',
    user_dtl: '/user/:user_id',
    pay_grp_list: '/pay_grp_list/',
  },
};

export const PageRoutesAuthenticated = () => {

  return (
    <Switch>
      <Route exact path={RoutePaths.root.pay_list} component={PayList}/>
      <Route exact path={RoutePaths.root.pay_ini} component={PayDtl}/>
      <Route exact path={RoutePaths.root.pay_dtl} component={PayDtl}/>
      <Route exact path={RoutePaths.root.exp_list} component={ExpList}/>
      <Route exact path={RoutePaths.root.exp_ini} component={ExpDtl}/>
      <Route exact path={RoutePaths.root.exp_dtl} component={ExpDtl}/>
      <Route exact path={RoutePaths.root.roy_list} component={RoyList}/>
      <Route exact path={RoutePaths.root.roy_ini} component={RoyDtl}/>
      <Route exact path={RoutePaths.root.roy_dtl} component={RoyDtl}/>
      <Route exact path={RoutePaths.root.item_list} component={ItemList}/>
      <Route exact path={RoutePaths.root.user_list} component={UserList}/>
      <Route exact path={RoutePaths.root.user_ini} component={UserDtl}/>
      <Route exact path={RoutePaths.root.user_dtl} component={UserDtl}/>
      <Route exact path={RoutePaths.root.pay_grp_list} component={PayGrpList}/>
    </Switch>
  );
};

export default PageRoutesAuthenticated;
